module.exports = __webpack_public_path__ + "static/firmyFullRating-5aa84c1cb5b86005b88d6890601cac98.svg";